import { useContext } from 'react';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import { useData } from '../../hooks/useData';
import { NavItem } from '../../types/appModels';
import { StatusUtil } from '../../types/appTypes';
import Spinner from '../../components/Common/Spinner/Spinner';
import StatusText from '../../components/Common/StatusText/StatusText';
import Card from '../../components/Common/Card/Card';
import NavigationList from '../../components/Navigation/NavigationList/NavigationList';
import { UserContext } from '../../context/userContext';
import { ADDITIONAL_NAV_ITEMS, ADMIN_NAV_ITEM } from '../../constants/navigation';
import css from './HomePage.module.css';

const HomePage = () => {
  const { dataState } = useData<NavItem[]>({
    endpoint: process.env.REACT_APP_API_NAVIGATION!,
    initialData: [],
  });
  const { checkRole, logout, checkUserType } = useContext(UserContext);

  const handleLogout = async () => {
    try {
      await logout!();
      window.location.reload();
    } catch (error) {
      alert(error);
    }
  };

  let display: JSX.Element = <></>;

  if (StatusUtil.isIdleOrLoading(dataState.status)) {
    display = (
      <Card flexDirection='column'>
        <Spinner />
      </Card>
    );
  
  } else if (StatusUtil.isFail(dataState.status)) {
    display = (
      <Card flexDirection='column' secondaryClass={css.card}>
        <StatusText
          text={`An error occurred and the navigation items could not be loaded. <br/> <span style="text-decoration: underline; cursor: pointer; color: inherit;" onclick="document.querySelector('[data-logout]').click()">Try logging out</span> and logging back in.`}
          error={true}
        />
        <button data-logout onClick={handleLogout} style={{ display: 'none' }} />
      </Card>
    );
  } else if (dataState.data === undefined || dataState.data.length === 0) {
    display = (
      <Card flexDirection='column'>
        <StatusText
          text='You do not have access to any navigation items.'
          error={true}
        />
      </Card>
    );
  } else {
    let additionalNavItems: NavItem[] = [...ADDITIONAL_NAV_ITEMS];

    // Filter out Document Store for Lite users
    if (checkUserType!('lite')) {
      additionalNavItems = additionalNavItems.filter(item => item.type !== 'documentstore');
    }

    if (checkRole && (checkRole('Admin') || checkRole('atlas.admin'))) {
      additionalNavItems.push(ADMIN_NAV_ITEM);
    }

    const navItemsWithActions: NavItem[] = [
      ...dataState.data,
      ...additionalNavItems,
    ];
    display = <NavigationList navItems={navItemsWithActions} />;
  }

  return <FullScreen>{display}</FullScreen>;
};

export default HomePage;